module.exports = __webpack_public_path__ + "img/asphalted_default.84ab74fd.png";